<template>
  <div class="layout-tags-content">
    <div class="add-tag-btn" @click="handleAdd">
      <img src="../../images/add-plus.png" />
      <span>添加常用</span>
    </div>
    <draggable
      ref="draggable"
      class="layout-tags-box"
      :list="tags"
      @change="onSortChange"
      v-bind="dragOptions">
      <div class="tag-box menu-tag" v-for="(tag, index) in tags" :key="tag.id" :class="{'first-tag': index === 0}">
        <!-- {{tag.title}} -->
        <span class="tag-text">{{tag.title}}</span>
        <el-dropdown @command="val => handleCommand(val, tag)">
          <div class="more-icon-box">
            <img src="../../images/more.svg" style="transform:translateY(0px);cursor:pointer" class="more-icon"/>
            <img src="../../images/more-hover.svg" style="transform:translateY(0px);cursor:pointer" class="more-icon-hover"/>
          </div>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item command="move" class="layout-tag-action-row"><img src="../../images/move.svg" alt="">移动到</el-dropdown-item>
            <el-dropdown-item command="delete" class="layout-tag-action-row"><img src="../../images/delete.svg" alt="">移除</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </div>
    </draggable>
  </div>
</template>

<script>
  import draggable from 'vuedraggable'
  export default {
    props: {
      tags: Array
    },
    components: { draggable },
    data() {
      return {
        dragOptions: {
          draggable: '.menu-tag',
          handle: '.menu-tag',
          animation: 150,
          ghostClass: 'kye-ghost'
        }
      }
    },
    methods: {
      handleCommand (command, tag) {
        this.$emit(command, tag)
      },
      handleAdd () {
        this.$emit('add')
      },
      onSortChange () {
        this.$emit('sortChange')
      }
    }
  }
</script>

<style lang="scss" scoped>
.layout-tags-content {
  height: 350px;
  border: 1px solid #E9E8ED;
  margin-left: 10px;
  padding: 12px 0 0 12px;
  overflow-y: auto;
  position: relative;
  flex: 1;
  &::-webkit-scrollbar {
    width: 6px;
    height: 6px;
  }

  &::-webkit-scrollbar-thumb {
    cursor: pointer;
    border-radius: 3px;
    background-color: rgba($color: #000000, $alpha: 0.4);
    border: 1px solid white;
  }

  &::-webkit-scrollbar-track {
    border: 0 solid transparent;
    background-color: #fff;
  }

  &::-webkit-scrollbar-corner {
    background: transparent;
  }

  &::-webkit-scrollbar-button {
    width: 0;
    height: 0;
    display: none;
  }
  .add-tag-btn {
    border: 1px solid #DCDCDC;
    color: var(--g-color-primary);
    cursor: pointer;
    height: 28px;
    align-items: center;
    width: fit-content;
    display: flex;
    position: absolute;
    padding: 0 8px;
    box-sizing: border-box;
    border-radius: 4px;
    font-size: 12px;
    margin: 0 12px 12px 0px;
    img {
      margin-right: 4px;
    }
  }
  .layout-tags-box {
    border-radius: 4px;
    display: flex;
    flex-wrap: wrap;
    .tag-box {
      height: 28px;
      align-items: center;
      width: fit-content;
      display: flex;
      padding: 0 8px;
      box-sizing: border-box;
      border-radius: 4px;
      font-size: 12px;
      margin: 0 12px 12px 0px;
      &.menu-tag {
        background: #F3F3FD;
        color: #333333;
        cursor: move;
      }
      &.first-tag {
        margin-left: 94px;
      }
      .tag-text {
        margin-right: 6px;
      }
    }
    .more-icon-box {
      width: 12px;
      height: 12px;
      .more-icon {
        display: block;
      }
      .more-icon-hover {
        display: none;
      }
      &:hover {
        .more-icon {
          display: none;
        }
        .more-icon-hover {
          display: block;
        }
      }
    }
  }
}
.layout-tag-action-row {
  display: flex;
  align-items: center;
  color: #000000 !important;
  &:hover {
    background: #EBECF0;
  }
  img {
    width: 12px;
    margin-right: 4px;
  }
}
</style>



// WEBPACK FOOTER //
// src/layout/pages/home/common-menu-card/menu-group-dialog/tag-list.vue